import { onCLS, onFCP, onINP, onLCP, onTTFB, Metric } from 'web-vitals';
import { createFileLogger } from './utils/logger';
import { analytics } from './services/analytics/analytics';

const log = createFileLogger('WEB_VITALS');

/** Real User Monitoring: forwards every Core Web Vital to the analytics
 * facade (see `web_vital_recorded` in services/analytics/events.ts) so
 * production performance regressions show up as real telemetry instead of
 * only being visible to whoever happens to open devtools locally. */
const reportToAnalytics = (metric: Metric) => {
  analytics.track('web_vital_recorded', {
    metric_name: metric.name as 'CLS' | 'INP' | 'FCP' | 'LCP' | 'TTFB',
    value: metric.value,
    rating: metric.rating,
    path: window.location.pathname,
  });
};

// Web Vitals reporting function
const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  const handleMetric = (metric: Metric) => {
    reportToAnalytics(metric);
    onPerfEntry?.(metric);
    if (process.env.NODE_ENV === 'development') {
      log.info(`Web Vital - ${metric.name}:`, {
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id
      });
    }
  };

  try {
    // Collect all Core Web Vitals
    onCLS(handleMetric);
    onINP(handleMetric); // FID has been replaced with INP (Interaction to Next Paint) in v5.x
    onFCP(handleMetric);
    onLCP(handleMetric);
    onTTFB(handleMetric);

    log.debug('Web Vitals monitoring initialized');
  } catch (error) {
    log.error('Failed to initialize Web Vitals:', error);
  }
};

// Support both named and default exports for compatibility
export { reportWebVitals };
export default reportWebVitals;